import { RunsProvider } from './context/RunsContext';
import { RunsView } from './RunsView';

export function RunsContainer() {
  return (
    <RunsProvider>
      <RunsView />
    </RunsProvider>
  );
}
